import './tasks-styles.css'
import { EmptyPost } from '#components/EmptyPost'
import { endpoints, request } from '#hooks'
import { EnoughWords } from '#tasks/EnoughWords'
import { FocusKeyword } from '#tasks/FocusKeyword'
import { ImagesAltText } from '#tasks/ImagesAltText'
import { KeywordInASubheader } from '#tasks/KeywordInASubheader'
import { MetaDescription } from '#tasks/MetaDescription'
import { PerfectTitle } from '#tasks/PerfectTitle'
import { Panel } from '@wordpress/components'
import { useEffect, useState } from '@wordpress/element'
import { useTranslation } from 'react-i18next'

export const Tasks = () => {
  const { t } = useTranslation()
  const [pop, setPop] = useState({ id: null, type: '', status: 'draft' })

  const getPop = async () => {
    const params = new URLSearchParams(window.location.search)
    const [slug] = window.location.pathname
      .split('/')
      .filter((str) => str.length)
      .slice(-1)

    if (params.get('post')) {
      try {
        const response = await Promise.allSettled([
          request(endpoints.pages.get(params.get('post'))),
          request(endpoints.posts.get(params.get('post'))),
        ])

        const {
          value: {
            data: { type, id, status },
          },
        } = response.find(({ status }) => status === 'fulfilled')
        setPop({ id, type, status })
      } catch (error) {
        console.log(error)
      }
    } else if (slug !== 'post-new.php') {
      const response = await Promise.allSettled([
        request({ ...endpoints.pages.get(), ...{ params: { slug } } }),
        request({ ...endpoints.posts.get(), ...{ params: { slug } } }),
      ])

      const {
        value: {
          data: [{ type, id, status }],
        },
      } = response.find(
        ({ status, value: { data } }) => status === 'fulfilled' && data.length
      )
      setPop({ id, type, status })
    }
  }

  useEffect(() => {
    getPop()
  }, [window.location.search])

  // TODO: avoid call at useTasks thanks to status at Elementor
  if (pop.status === 'draft') return <EmptyPost></EmptyPost>

  return (
    <div className="mktseo">
      <Panel header={t('sidebar.tasks.wrapper.header')}>
        <FocusKeyword pop={pop} />
        <PerfectTitle pop={pop} />
        <MetaDescription pop={pop} />
        <KeywordInASubheader pop={pop} />
        <ImagesAltText pop={pop} />
        <EnoughWords pop={pop} />
      </Panel>
    </div>
  )
}
